import type { TemplateIds } from '../../models/uv-inserts/template-ids';

/**
 * Resolve a UV insert template ID from templateIds using common variant key formats.
 * Supports numeric keys, plain string IDs, and Shopify ProductVariant GID keys.
 */
export function resolveTemplateIdByVariantId(options: {
  templateIds: TemplateIds | null | undefined;
  variantId: string | number | null | undefined;
}): string | null {
  const { templateIds, variantId } = options;

  if (!templateIds || variantId === null || variantId === undefined) return null;

  const rawVariantId = String(variantId).trim();
  const numericVariantId = rawVariantId.replace(/\D/g, '');
  const gidVariantId = 'gid:' + '/' + '/shopify' + '/' + 'ProductVariant' + '/' + (numericVariantId || rawVariantId);

  const directMatch =
    templateIds[variantId as unknown as keyof TemplateIds] ??
    templateIds[rawVariantId as unknown as keyof TemplateIds] ??
    templateIds[numericVariantId as unknown as keyof TemplateIds] ??
    templateIds[gidVariantId as unknown as keyof TemplateIds];

  if (directMatch) return directMatch;

  const templateEntry = Object.entries(templateIds).find(([key]) => {
    const keyStr = String(key);
    if (keyStr === rawVariantId || keyStr === numericVariantId || keyStr === gidVariantId) return true;
    return keyStr.includes('/ProductVariant/') && keyStr.endsWith(`/${numericVariantId || rawVariantId}`);
  });

  return templateEntry?.[1] || null;
}
